<template>
  <div class="container mt-5 pl-xl-5">
    <loading loader="bars" :active.sync="isLoading"></loading>
    <div class="row ml-5 pl-3 ml-xl-0 pl-xl-0 setting">
      <div class="col-12">
        <div class="row">
          <div class="col-12 col-sm-4">
            <div class="form-group">
              <label class="titleFontSize" for="BusinessName">店家名稱</label>
              <input type="text" class="form-control" id="BusinessName" v-model="data.BusinessName" />
            </div>
            <div class="form-group">
              <label class="titleFontSize" for="Tel">店家電話</label>
              <input type="text" class="form-control" id="Tel" v-model="data.Tel" />
            </div>
            <div class="form-group">
              <label class="titleFontSize" for="Industry">行業類別</label>
              <select id="Industry" class="form-control" v-model="data.Industry">
                <option
                  v-for="(item, index) in industry"
                  :key="index"
                  :value="item.name"
                >{{item.name}}</option>
              </select>
            </div>
          </div>
          <div class="col-12 col-sm-8">
            <div class="titleFontSize">店家圖片</div>
            <ul class="row m-0 p-0">
              <li class="col-6 col-sm-3 mb-2">
                <div class="photoBox position-relative overflow-hidden">
                  <label class="w-25 h-25" for="imgbtn1">
                    <img src="@/assets/img/landscape-electronics.svg" v-if="!data.PictureAddress1" />
                    <img
                      class="position-absolute w-25 h-25 upd"
                      src="@/assets/img/refresh.svg"
                      v-if="data.PictureAddress1"
                    />
                  </label>
                  <img
                    class="position-absolute w-25 h-25 del"
                    src="@/assets/img/cancel.svg"
                    v-if="data.PictureAddress1"
                    @click="data.PictureAddress1 = ''"
                  />
                  <input
                    id="imgbtn1"
                    type="file"
                    @change="readURL"
                    targetID="PictureAddress1"
                    accept="image/gif, image/jpeg, image/png"
                    v-show="false"
                  />
                  <img class="img-fluid" id="PictureAddress1" :src="data.PictureAddress1" />
                </div>
              </li>
              <li class="col-6 col-sm-3 mb-2">
                <div class="photoBox position-relative overflow-hidden">
                  <label class="w-25 h-25" for="imgbtn2">
                    <img src="@/assets/img/landscape-electronics.svg" v-if="!data.PictureAddress2" />
                    <img
                      class="position-absolute w-25 h-25 upd"
                      src="@/assets/img/refresh.svg"
                      v-if="data.PictureAddress2"
                    />
                  </label>
                  <img
                    class="position-absolute w-25 h-25 del"
                    src="@/assets/img/cancel.svg"
                    v-if="data.PictureAddress2"
                    @click="data.PictureAddress2 = ''"
                  />
                  <input
                    id="imgbtn2"
                    type="file"
                    @change="readURL"
                    targetID="PictureAddress2"
                    accept="image/gif, image/jpeg, image/png"
                    v-show="false"
                  />
                  <img class="img-fluid" id="PictureAddress2" :src="data.PictureAddress2" />
                </div>
              </li>
              <li class="col-6 col-sm-3 mb-2">
                <div class="photoBox position-relative overflow-hidden">
                  <label class="w-25 h-25" for="imgbtn3">
                    <img src="@/assets/img/landscape-electronics.svg" v-if="!data.PictureAddress3" />
                    <img
                      class="position-absolute w-25 h-25 upd"
                      src="@/assets/img/refresh.svg"
                      v-if="data.PictureAddress3"
                    />
                  </label>
                  <img
                    class="position-absolute w-25 h-25 del"
                    src="@/assets/img/cancel.svg"
                    v-if="data.PictureAddress3"
                    @click="data.PictureAddress3 = ''"
                  />
                  <input
                    id="imgbtn3"
                    type="file"
                    @change="readURL"
                    targetID="PictureAddress3"
                    accept="image/gif, image/jpeg, image/png"
                    v-show="false"
                  />
                  <img class="img-fluid" id="PictureAddress3" :src="data.PictureAddress3" />
                </div>
              </li>
              <li class="col-6 col-sm-3 mb-2">
                <div class="photoBox position-relative overflow-hidden">
                  <label class="w-25 h-25" for="imgbtn4">
                    <img src="@/assets/img/landscape-electronics.svg" v-if="!data.PictureAddress4" />
                    <img
                      class="position-absolute w-25 h-25 upd"
                      src="@/assets/img/refresh.svg"
                      v-if="data.PictureAddress4"
                    />
                  </label>
                  <img
                    class="position-absolute w-25 h-25 del"
                    src="@/assets/img/cancel.svg"
                    v-if="data.PictureAddress4"
                    @click="data.PictureAddress4 = ''"
                  />
                  <input
                    id="imgbtn4"
                    type="file"
                    @change="readURL"
                    targetID="PictureAddress4"
                    accept="image/gif, image/jpeg, image/png"
                    v-show="false"
                  />
                  <img class="img-fluid" id="PictureAddress4" :src="data.PictureAddress4" />
                </div>
              </li>
              <li class="col-6 col-sm-3 mb-2">
                <div class="photoBox position-relative overflow-hidden">
                  <label class="w-25 h-25" for="imgbtn5">
                    <img src="@/assets/img/landscape-electronics.svg" v-if="!data.PictureAddress5" />
                    <img
                      class="position-absolute w-25 h-25 upd"
                      src="@/assets/img/refresh.svg"
                      v-if="data.PictureAddress5"
                    />
                  </label>
                  <img
                    class="position-absolute w-25 h-25 del"
                    src="@/assets/img/cancel.svg"
                    v-if="data.PictureAddress5"
                    @click="data.PictureAddress5 = ''"
                  />
                  <input
                    id="imgbtn5"
                    type="file"
                    @change="readURL"
                    targetID="PictureAddress5"
                    accept="image/gif, image/jpeg, image/png"
                    v-show="false"
                  />
                  <img class="img-fluid" id="PictureAddress5" :src="data.PictureAddress5" />
                </div>
              </li>
              <li class="col-6 col-sm-3 mb-2">
                <div class="photoBox position-relative overflow-hidden">
                  <label class="w-25 h-25" for="imgbtn6">
                    <img src="@/assets/img/landscape-electronics.svg" v-if="!data.PictureAddress6" />
                    <img
                      class="position-absolute w-25 h-25 upd"
                      src="@/assets/img/refresh.svg"
                      v-if="data.PictureAddress6"
                    />
                  </label>
                  <img
                    class="position-absolute w-25 h-25 del"
                    src="@/assets/img/cancel.svg"
                    v-if="data.PictureAddress6"
                    @click="data.PictureAddress6 = ''"
                  />
                  <input
                    id="imgbtn6"
                    type="file"
                    @change="readURL"
                    targetID="PictureAddress6"
                    accept="image/gif, image/jpeg, image/png"
                    v-show="false"
                  />
                  <img class="img-fluid" id="PictureAddress6" :src="data.PictureAddress6" />
                </div>
              </li>
              <li class="col-6 col-sm-3 mb-2">
                <div class="photoBox position-relative overflow-hidden">
                  <label class="w-25 h-25" for="imgbtn7">
                    <img src="@/assets/img/landscape-electronics.svg" v-if="!data.PictureAddress7" />
                    <img
                      class="position-absolute w-25 h-25 upd"
                      src="@/assets/img/refresh.svg"
                      v-if="data.PictureAddress7"
                    />
                  </label>
                  <img
                    class="position-absolute w-25 h-25 del"
                    src="@/assets/img/cancel.svg"
                    v-if="data.PictureAddress7"
                    @click="data.PictureAddress7 = ''"
                  />
                  <input
                    id="imgbtn7"
                    type="file"
                    @change="readURL"
                    targetID="PictureAddress7"
                    accept="image/gif, image/jpeg, image/png"
                    v-show="false"
                  />
                  <img class="img-fluid" id="PictureAddress7" :src="data.PictureAddress7" />
                </div>
              </li>
              <li class="col-6 col-sm-3 mb-2">
                <div class="photoBox position-relative overflow-hidden">
                  <label class="w-25 h-25" for="imgbtn8">
                    <img src="@/assets/img/landscape-electronics.svg" v-if="!data.PictureAddress8" />
                    <img
                      class="position-absolute w-25 h-25 upd"
                      src="@/assets/img/refresh.svg"
                      v-if="data.PictureAddress8"
                    />
                  </label>
                  <img
                    class="position-absolute w-25 h-25 del"
                    src="@/assets/img/cancel.svg"
                    v-if="data.PictureAddress8"
                    @click="data.PictureAddress8 = ''"
                  />
                  <input
                    id="imgbtn8"
                    type="file"
                    @change="readURL"
                    targetID="PictureAddress8"
                    accept="image/gif, image/jpeg, image/png"
                    v-show="false"
                  />
                  <img class="img-fluid" id="PictureAddress8" :src="data.PictureAddress8" />
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="titleFontSize">店家地址</div>
        <div class="form-row">
          <div class="form-group col-md-3">
            <label for="inputCity">縣/市</label>
            {{data.City}}
            <select
              id="inputCity"
              class="form-control"
              v-model="data.City"
            >
              <option
                v-for="(item, index) in city"
                :key="index"
                :value="item.CityName"
              >{{item.CityName}}</option>
            </select>
          </div>
          <div class="form-group col-md-3">
            <label for="inputState">鄉/鎮</label>
            <select id="inputState" class="form-control" v-model="data.Area">
              <option
                v-for="(item, index) in township"
                :key="index"
                :value="item.AreaName"
              >{{item.AreaName}}</option>
            </select>
          </div>
          <div class="form-group col-md-6">
            <label for="inputZip">層樓,街/道</label>
            <input type="text" class="form-control" id="inputZip" v-model="data.Address" />
          </div>
        </div>
      </div>
      <div class="col-12 d-flex justify-content-between">
        <button
          type="button"
          class="btn btn-outline-secondary"
          data-toggle="collapse"
          data-target="#collapseExample"
          aria-expanded="false"
          aria-controls="collapseExample"
        >更新密碼</button>
        <button type="button" class="btn btn-outline-secondary" @click="updBusinessData">儲存</button>
      </div>
      <SettingPed />
    </div>
  </div>
</template>
<script>
import SettingPed from '@/components/SettingPwd.vue'
export default {
  components: {
    SettingPed
  },
  data () {
    return {
      data: {},
      city: [],
      industry: [],
      PictureAddress1: {},
      PictureAddress2: {},
      PictureAddress3: {},
      PictureAddress4: {},
      PictureAddress5: {},
      PictureAddress6: {},
      PictureAddress7: {},
      PictureAddress8: {},
      isLoading: false
    }
  },
  computed: {
    township () {
      var arr = []
      if (this.data.City) {
        this.city.forEach(element => {
          if (this.data.City === element.CityName) {
            arr = element.AreaList
          }
        })
        return arr
      } else {
        return []
      }
    }
  },
  methods: {
    readURL (input) {
      var str = input.path[1].lastElementChild.id
      const vm = this
      this[str] = input.target.files[0]
      console.log(input.target.files[0])
      // this.data[str] = input.path[1].lastElementChild.src
      if (input.path[0].files && input.path[0].files[0]) {
        var imageTagID = input.path[0].getAttribute('targetID')

        var reader = new FileReader()

        reader.onload = function (e) {
          var img = document.getElementById(imageTagID)

          img.setAttribute('src', e.target.result)
          vm.data[str] = e.target.result
        }

        reader.readAsDataURL(input.path[0].files[0])
      }
    },
    address () {
      this.axios
        .get(
          'https://raw.githubusercontent.com/donma/TaiwanAddressCityAreaRoadChineseEnglishJSON/master/CityCountyData.json',
          { withCredentials: false }
        )
        .then(res => {
          this.city = res.data
        })
        .catch(error => {
          console.error(error)
        })
    },
    updBusinessData () {
      const vm = this
      const fd = new FormData()
      const url = 'http://imrebooksystem.rocket-coding.com/BusinessUsers/BusinessUserEdit'
      fd.append('Id', this.data.Id)
      fd.append('BusinessName', this.data.BusinessName)
      fd.append('Industry', this.data.Industry)
      fd.append('Tel', this.data.Tel)
      fd.append('City', this.data.City)
      fd.append('Area', this.data.Area)
      fd.append('Address', this.data.Address)
      fd.append('files1', this.PictureAddress1)
      fd.append('files2', this.PictureAddress2)
      fd.append('files3', this.PictureAddress3)
      fd.append('files4', this.PictureAddress4)
      fd.append('files5', this.PictureAddress5)
      fd.append('files6', this.PictureAddress6)
      fd.append('files7', this.PictureAddress7)
      fd.append('files8', this.PictureAddress8)
      this.axios
        .post(url, fd)
        .then(function (res) {
          if (res.data === '編輯成功') {
            vm.$swal({
              position: 'top-end',
              background: '#F7ECEB',
              icon: 'success',
              title: '編輯成功',
              showConfirmButton: false,
              toast: true,
              timer: 3000,
              timerProgressBar: true,
              onOpen: (toast) => {
                toast.addEventListener('mouseenter', vm.$swal.stopTimer)
                toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
              }
            })
          } else {
            vm.$swal({
              position: 'top-end',
              background: '#F7ECEB',
              icon: 'error',
              title: res.data,
              showConfirmButton: false,
              toast: true,
              timer: 3000,
              timerProgressBar: true,
              onOpen: (toast) => {
                toast.addEventListener('mouseenter', vm.$swal.stopTimer)
                toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
              }
            })
          }
        })
        .catch(error => console.error(error))
    }
  },
  created () {
    this.isLoading = true
    const adminEmail = JSON.parse(sessionStorage.getItem('admin'))
    const url = 'http://imrebooksystem.rocket-coding.com/BusinessUsers/GetUserInfo'
    const adminDataUrl = 'http://imrebooksystem.rocket-coding.com/BusinessUsers/BusinessUserEdit'
    const vm = this
    vm.address()
    this.axios
      .get(url, { params: { email: adminEmail } })
      .then(function (res) {
        const adminId = res.data.Id
        // vm.isLoading = false
        vm.axios
          .get(adminDataUrl, { params: { Id: adminId } })
          .then(function (res) {
            vm.data = res.data
            vm.isLoading = false
          })
          .catch(error => console.error(error))
      })
      .catch(error => console.error(error))
  },
  mounted () {
    this.axios
      .get('./industry.json')
      .then(res => {
        this.industry = res.data
      })
      .catch(error => {
        console.error(error)
      })
  }
}
</script>

<style lang="scss" scoped>
.setting {
  color: #b8817d;
  .card,
  input,
  select {
    background-color: transparent;
  }
  input,
  select:focus {
    background-color: transparent !important;
  }
  .card {
    border: 1px solid #dadbe6;
    color: #b8817d;
  }
  .photoBox {
    height: 137px;
    border: 1px solid #dadbe6;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    .upd {
      bottom: 0px;
      right: 40px;
      z-index: 1;
    }
    .del {
      bottom: 0px;
      right: 0px;
      z-index: 1;
    }
  }
}
.titleFontSize {
  font-size: 2rem;
}
</style>
